import type { PipelineOption } from './types';

// Pipeline options - predefined filter combinations for the Workflow dropdown.
// Kept in its own module (not ProspectFilters.tsx) so it can be imported by
// tests without tripping react-refresh/only-export-components.
export const PIPELINE_OPTIONS: PipelineOption[] = [
  {
    id: 'post_closing',
    label: 'Post Closing',
    description: ''
  },
  {
    id: 'mers_audit',
    label: 'MERS Transfer Date Audit',
    description: ''
  }
];
